export default "__VITE_ASSET__DsbmAMFO__"